import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Layout from './components/layouts/MobileLayout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import BrandsPicker from './pages/Brands/Picker'
import StockItemsList from './pages/StockItems/List'
import StockItemDetail from './pages/StockItems/Detail'
import StockItemEdit from './pages/StockItems/Edit'
import BundlesList from './pages/Bundles/List'
import BundleDetail from './pages/Bundles/Detail'
import ProductsList from './pages/Products/List'
import ProductDetail from './pages/Products/Detail'
import CreateProduct from './pages/Products/Create'
import EditProduct from './pages/Products/Edit'
import ListingsList from './pages/Listings/List'
import ListingDetail from './pages/Listings/Detail'
import ListingEdit from './pages/Listings/Edit'
import InventoryList from './pages/Inventory/List'
import InventoryDetail from './pages/Inventory/Detail'
import ListingCreate from './pages/Listings/Create'
import ImportEtsy from './pages/Import/Etsy'
import ChannelSelector from './pages/Import/ChannelSelector'
import Settings from './pages/Settings'
import EtsyConfigSetsList from './pages/Integrations/Etsy/List'
import EtsyConfigSetDetail from './pages/Integrations/Etsy/Detail'
import EtsyConfigSetEdit from './pages/Integrations/Etsy/Edit'
import EtsyProductsList from './pages/Integrations/Etsy/ProductsList'
import EtsyProductDetail from './pages/Integrations/Etsy/ProductDetail'
import EtsyOrdersList from './pages/Integrations/Etsy/OrdersList'
import EtsyOrderDetail from './pages/Integrations/Etsy/OrderDetail'
import PrintifyProductsList from './pages/Integrations/Printify/List'
import PrintifyProductDetail from './pages/Integrations/Printify/Detail'

function LegacyToBrandPickerRedirect() {
  const location = useLocation()
  const returnTo = `${location.pathname}${location.search}`
  return <Navigate to={`/brands/picker?returnTo=${encodeURIComponent(returnTo)}`} replace />
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />

      <Route
        path="/brands/picker"
        element={
          <ProtectedRoute>
            <Layout>
              <BrandsPicker />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock-items"
        element={
          <ProtectedRoute>
            <Layout>
              <StockItemsList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock-items/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <StockItemDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock-items/:id/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <StockItemEdit />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/bundles"
        element={
          <ProtectedRoute>
            <Layout>
              <BundlesList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/bundles/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <BundleDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <Layout>
              <ProductsList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/new"
        element={
          <ProtectedRoute>
            <Layout>
              <CreateProduct />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <ProductDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/:id/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <EditProduct />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/listings"
        element={
          <ProtectedRoute>
            <Layout>
              <ListingsList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/listings/new"
        element={
          <ProtectedRoute>
            <Layout>
              <ListingCreate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/listings/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <ListingDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/listings/:id/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <ListingEdit />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <ProtectedRoute>
            <Layout>
              <InventoryList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <InventoryDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/import"
        element={
          <ProtectedRoute>
            <Layout>
              <ChannelSelector />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/import/etsy"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/import/etsy"
        element={
          <ProtectedRoute>
            <Layout>
              <ImportEtsy />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <Settings />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/etsy"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/etsy"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyConfigSetsList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/etsy/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/etsy/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyConfigSetDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/etsy/:id/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/etsy/:id/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyConfigSetEdit />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/etsy/products"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/etsy/products/:shopId/:listingId"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/etsy/products"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyProductsList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/etsy/products/:shopId/:listingId"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyProductDetail />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/brands/:brandId/integrations/etsy/orders"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyOrdersList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/etsy/orders/:shopId/:receiptId"
        element={
          <ProtectedRoute>
            <Layout>
              <EtsyOrderDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/printify"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/printify/:shopId/:productId"
        element={
          <ProtectedRoute>
            <Layout>
              <LegacyToBrandPickerRedirect />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/printify"
        element={
          <ProtectedRoute>
            <Layout>
              <PrintifyProductsList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/brands/:brandId/integrations/printify/:shopId/:productId"
        element={
          <ProtectedRoute>
            <Layout>
              <PrintifyProductDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Legacy/wireframe path → redirect to inventory */}
      <Route path="/zoho-inventory" element={<Navigate to="/inventory" replace />} />
      {/* Add more protected routes here */}
    </Routes>
  )
}

export default App
